var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef, useMemo } from 'react';
import styled from 'styled-components';
import { ListContainer } from './elements';
import { ListItem } from './ListItem';
var HiddenAriaText = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  height: 0;\n  opacity: 0;\n  position: absolute;\n"], ["\n  height: 0;\n  opacity: 0;\n  position: absolute;\n"])));
export var ProgressStepper = forwardRef(function (_a, fRef) {
    var steps = _a.steps, size = _a.size, orientation = _a.orientation, isPacked = _a.isPacked, rest = __rest(_a, ["steps", "size", "orientation", "isPacked"]);
    var ariaLabel = useMemo(function () {
        var _a, _b;
        var currentStepIndex = steps
            .map(function (step) { return step.state !== 'incomplete'; })
            .lastIndexOf(true);
        var currentStep = steps[currentStepIndex];
        var label = "step ".concat(currentStepIndex + 1, " out of ").concat(steps.length);
        if (!((_a = currentStep === null || currentStep === void 0 ? void 0 : currentStep.subSteps) === null || _a === void 0 ? void 0 : _a.length)) {
            return label;
        }
        if (currentStep.state === 'inprogress') {
            return "".concat(label, " part 1");
        }
        var subStepIndex = (_b = currentStep.subSteps) === null || _b === void 0 ? void 0 : _b.findIndex(function (subStep) { return subStep.state === 'inprogress'; });
        if (subStepIndex !== undefined) {
            return "".concat(label, " part ").concat(subStepIndex + 2);
        }
        return label;
    }, [steps]);
    return (React.createElement(React.Fragment, null,
        React.createElement(HiddenAriaText, null, ariaLabel),
        React.createElement(ListContainer, __assign({ ref: fRef, "aria-hidden": true, "data-testid": "progress-stepper", orientation: orientation }, rest), steps.map(function (step, index) { return (React.createElement(ListItem, __assign({}, step, { key: index, index: index, stepsAmount: steps.length, size: size, orientation: orientation, isPacked: isPacked }))); }))));
});
var templateObject_1;
